import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

require.ensure([], () => {
    require('./WeekSheetApproval.less');
});

class WeekView extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            dates: [],
            logEntriesByDate: [[], [], [], [], [], [], []]
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        let dates = [];
        let logEntriesByDate = [[], [], [], [], [], [], []];
        for (let i = nextProps.logEntriesOnWeekForUser.length - 1; i >= 0; i--) {
            let logEntryDate = moment(nextProps.logEntriesOnWeekForUser[i].date, "YYYY-MM-DD");

            if (!this.state) break;

            let diff = logEntryDate.diff(moment(nextProps.date.format("YYYY-MM-DD"), "YYYY-MM-DD"), 'days');

            if (diff < 0 || diff > 6) break;

            dates.push(logEntryDate);
            logEntriesByDate[diff].push(nextProps.logEntriesOnWeekForUser[i]);
        }

        this.setState({
            dates: dates,
            logEntriesByDate: logEntriesByDate
        });

    };

    // EVENT HANDLERS

    handleClick = () => {
        this.props.handleClick();
    };

    // RENDER METHOD

    render = () => {
        if (this.props.active) {
            return (
                <div className="panel panel-default panel-pmtask">
                    <div className="panel-heading" role="tab" id="headingOne-inner">
                        <h4 className="panel-title">
                            <a style={{"cursor" : "pointer"}} onClick={this.handleClick} data-toggle="collapse" data-parent="#accordion-inner" aria-expanded="true" aria-controls="collapseOne">
                                <span className="acc" style={{borderColor : "#888"}}>
                                    <span className="md-expand-more" style={{"color": "#888"}}/>
                                </span>
                                Weekly work by days
                            </a>
                        </h4>
                    </div>
                        <div className="scrollable-div content modal-body">
                            <h4>{this.props.usersName}</h4>
                            {
                              this.state.logEntriesByDate.map((logEntries, key) => {
                                if (logEntries.length > 0) {
                                  let date = logEntries[0].date;
                                  return (
                                    <span key={key}>
                                              <hr/>
                                              <h5 style={{fontWeight: 'bold'}}>{moment(date, "YYYY-MM-DD").format("dddd DD.MM.YYYY.")}</h5>
                                      {
                                        logEntries.map((logEntry, logEntryKey) => {
                                          let hours = Math.trunc(logEntry.duration / 60);
                                          let minutes = parseFloat((logEntry.duration % 60).toFixed(0));
                                          return (
                                            <div key={logEntryKey}>
                                              <span style={{fontWeight: 'bold'}}>{logEntry.projectName} - {logEntry.taskName}</span>
                                              <span className="pull-right" style={logEntry.overtime ? {"color": "red"} : {}}>{hours + "h"}{minutes > 0 ? " " + minutes + "min" : ""} </span><br/>
                                              <span style={{"maxWidth": "90%", wordWrap: "break-word"}}>{logEntry.description}</span>
                                            </div>
                                          );
                                        })
                                      }
                                    </span>
                                  );
                                }
                              })
                            }
                        </div>
                </div>
            );
        } else {
            return (
                <div className="panel panel-default panel-pmtask">
                    <div className="panel-heading" role="tab" id="headingOne-inner">
                        <h4 className="panel-title">
                            <a style={{"cursor" : "pointer"}} onClick={this.handleClick} data-toggle="collapse" data-parent="#accordion-inner" aria-expanded="true" aria-controls="collapseOne">
                                <span className="acc" style={{borderColor : "#888"}}>
                                    <span className="md-chevron-right" style={{"color": "#888"}}/>
                                </span>
                                Weekly work by days
                            </a>
                        </h4>
                    </div>
                </div>
            );
        }
    }
}

WeekView.propTypes = {
    active: PropTypes.bool,
    date: PropTypes.object,
    handleClick: PropTypes.func,
    logEntriesByTimesheet: PropTypes.object,
    usersName: PropTypes.string
};

WeekView.defaultProps = {
    date: moment().day(1)
};

const mapStateToProps = (state) => {
    return {
        logEntriesOnWeekForUser: state.logEntries.logEntriesOnWeekForUser,
    };
};

export default connect(
    mapStateToProps
)(WeekView);



/** WEBPACK FOOTER **
 ** ./src/app/components/WeekView.js
 **/